import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
})

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// Blog API
export const blogAPI = {
  getPosts: (page = 1, limit = 10, category = '') =>
    api.get(`/blog/posts?page=${page}&limit=${limit}${category ? `&category=${category}` : ''}`),
  getPost: (slug) => api.get(`/blog/posts/${slug}`),
  getCategories: () => api.get('/blog/categories'),
  createComment: (postId, data) => api.post(`/blog/posts/${postId}/comments`, data),
}

// Forum API
export const forumAPI = {
  getTopics: (page = 1, limit = 15) => api.get(`/forum/topics?page=${page}&limit=${limit}`),
  getTopic: (slug) => api.get(`/forum/topics/${slug}`),
  createTopic: (data) => api.post('/forum/topics', data),
  createReply: (topicId, data) => api.post(`/forum/topics/${topicId}/replies`, data),
}

// Products API
export const productsAPI = {
  getProducts: () => api.get('/products'),
  getProduct: (slug) => api.get(`/products/${slug}`),
}

// Contact API
export const contactAPI = {
  submit: (data) => api.post('/contact', data),
}

// Banners API
export const bannersAPI = {
  getActive: () => api.get('/banners'),
  getAll: () => api.get('/banners/all'),
  create: (data) => api.post('/banners', data),
  update: (id, data) => api.put(`/banners/${id}`, data),
  delete: (id) => api.delete(`/banners/${id}`),
}

// Team API
export const teamAPI = {
  getActive: () => api.get('/team'),
  getAll: () => api.get('/team/all'),
  create: (data) => api.post('/team', data),
  update: (id, data) => api.put(`/team/${id}`, data),
  delete: (id) => api.delete(`/team/${id}`),
}

// FAQ API
export const faqAPI = {
  getActive: () => api.get('/faq'),
  getAll: () => api.get('/faq/all'),
  create: (data) => api.post('/faq', data),
  update: (id, data) => api.put(`/faq/${id}`, data),
  delete: (id) => api.delete(`/faq/${id}`),
}

// Testimonials API
export const testimonialsAPI = {
  getActive: () => api.get('/testimonials'),
  getAll: () => api.get('/testimonials/all'),
  create: (data) => api.post('/testimonials', data),
  update: (id, data) => api.put(`/testimonials/${id}`, data),
  delete: (id) => api.delete(`/testimonials/${id}`),
}

// Dashboard API
export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
}

// Settings API
export const settingsAPI = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
}

// Alliances API
export const alliancesAPI = {
  getActive: () => api.get('/alliances'),
  getAll: () => api.get('/alliances/all'),
  create: (data) => api.post('/alliances', data),
  update: (id, data) => api.put(`/alliances/${id}`, data),
  delete: (id) => api.delete(`/alliances/${id}`),
}

// Stats API
export const statsAPI = {
  getActive: () => api.get('/stats'),
  getAll: () => api.get('/stats/all'),
  create: (data) => api.post('/stats', data),
  update: (id, data) => api.put(`/stats/${id}`, data),
  delete: (id) => api.delete(`/stats/${id}`),
}

// Instagram API
export const instagramAPI = {
  getActive: () => api.get('/instagram'),
  getAll: () => api.get('/instagram/all'),
  fetchOEmbed: (url) => api.get(`/instagram/oembed?url=${encodeURIComponent(url)}`),
  create: (data) => api.post('/instagram', data),
  update: (id, data) => api.put(`/instagram/${id}`, data),
  delete: (id) => api.delete(`/instagram/${id}`),
}

// Downloadables API
export const downloadablesAPI = {
  getAll: () => api.get('/downloadables'),
  getOne: (slug) => api.get(`/downloadables/${slug}`),
  trackDownload: (id) => api.post(`/downloadables/${id}/download`),
}

// Upload API
export const uploadAPI = {
  uploadImage: (file) => {
    const formData = new FormData()
    formData.append('image', file)
    return api.post('/upload/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  uploadBannerImage: (file) => {
    const formData = new FormData()
    formData.append('image', file)
    return api.post('/upload/banner', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
}

export default api
